// import wikiImg from '../../image/wikipediaExternalPage.png'
import headshot from '../../image/gregHeadshot-50.png'
import funride from '../../lib/funride/funride.module.less'
import ManagersContext from '../../containers/ManagersContext'
import React, { useContext } from 'react'

export default function InnerPageHome() {
  const { objResume } = useContext(ManagersContext)
  const resume = objResume.resume

  return (
    <header>
      <h1>Web Software Engineer</h1>
      <p id={funride['pagehome-bio']}>
        <img alt="Photo of Greg Sandell" id={funride.headshot} src={headshot} />{' '}
        {resume.qualSummary.map((qual: string, m: number) => (
          <span key={`q${m}`}>{qual}</span>
        ))}
      </p>
      <div>&nbsp;</div>
    </header>
  )
}
